// extracted by mini-css-extract-plugin
module.exports = {"relatedNews":"q1wUrT","newsItem":"_5HXtTg","featured":"_7qbj3p","newsItemHeader":"_6fdIoL","newsItemTitle":"w8xlxS","newsItemText":"rsv1hx","neaturedLabel":"_v55Md"};